import {Card} from "../../../../components/card/card.jsx";
import {FaRegImages} from "react-icons/fa";
import {useRef} from "react";

export default function LibraryDropzone({ isSearching, onSelectFile, hasPermission }) {
    const inputFileRef = useRef(null);

    function handleClick(event) {
        event.stopPropagation();

        if (isSearching) return;
        if (!onSelectFile) return;

        inputFileRef.current?.click();
    }

    function handleFileChange(event) {
        const files = event.target.files;

        if (!files || files.length === 0) return;

        onSelectFile(files);

        event.target.value = "";
    }

    return (
        <Card className="h-full">
            <Card.Body>
                {hasPermission ? (
                    <div
                        className={`
                        flex h-full min-h-[calc(100vh-264px)] items-center justify-center
                        ${!isSearching && onSelectFile ? "cursor-pointer" : ""}
                    `}
                        onClick={handleClick}
                    >
                        <input
                            type="file"
                            ref={inputFileRef}
                            className="hidden"
                            multiple
                            onChange={handleFileChange}
                        />
                        {isSearching ? (
                            <h4 className="font-semibold text-[#676A7C]">Nenhum resultado encontrado</h4>
                        ) : (
                            <div className="flex flex-col items-center select-none">
                                <FaRegImages size={130} />
                                <h4 className="text-center text-xl! font-bold">
                                    Clique aqui ou<br/> arraste e solte um arquivo
                                </h4>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="flex h-full min-h-[calc(100vh-264px)] items-center justify-center">
                        Sem dados para exibir
                    </div>
                )}
            </Card.Body>
        </Card>
    )
}